export const markets = [
    'af_ZA_ZAR',
    'ar_AE_AED',
    'ar_LB_LBP',
    'bg_BG_BGN',
    'cs_CZ_CZK',
    'da_DK_DKK',
    'de_AT_EUR',
    'de_BE_EUR',
    'de_CH_CHF',
    'de_CH_EUR',
    'de_DE_CHF',
    'de_DE_EUR',
    'el_EL_EUR',
    'el_GR_EUR',
    'en_AU_AUD',
    'en_AU_USD',
    'en_CA_CAD',
    'en_CA_USD',
    'en_EN_GBP',
    'en_EN_USD',
    'en_FR_EUR',
    'en_GB_GBP',
    'en_HK_HKD',
    'en_IE_EUR',
    'en_IN_USD',
    'en_KR_USD',
    'en_LB_LBP',
    'en_MT_EUR',
    'en_NG_NGN',
    'en_NL_EUR',
    'en_NZ_NZD',
    'en_NZ_USD',
    'en_SG_SGD',
    'en_SG_USD',
    'en_US_CAD',
    'en_US_EUR',
    'en_US_GBP',
    'en_US_INR',
    'en_US_USD',
    'es_AR_ARS',
    'es_CL_CLP',
    'es_CL_USD',
    'es_ES_EUR',
    'es_MX_MXN',
    'es_MX_USD',
    'fr_BE_EUR',
    'fr_CA_CAD',
    'fr_CA_USD',
    'fr_CH_CHF',
    'fr_ES_EUR',
    'fr_FR_CHF',
    'fr_FR_EUR',
    'fr_FR_USD',
    'fr_LU_EUR',
    'ge_AT_EUR',
    'il_IL_ILS',
    'in_IN_INR',
    'it_CH_CHF',
    'it_IT_EUR',
    'ja_JP_JPY',
    'jp_JP_JPY',
    'kr_KR_KRW',
    'lb_LB_LBP',
    'ms_MY_MYR',
    'nl_BE_EUR',
    'nl_NL_EUR',
    'no_NO_NOK',
    'pl_PL_PLN',
    'pt_BR_BRL',
    'pt_PT_EUR',
    'ru_RU_RUB',
    'sk_SK_EUR',
    'sv_SE_SEK',
    'uk_UA_UAH',
    'zh_CN_CNY',
    'zh_HK_HKD',
    'zh_TW_USD',
];
//# sourceMappingURL=markets.js.map